import React, {Component} from 'react';
import Header from "./header";
import katalog from './assets/img/newkatalog.mp4';
import { albumEbads } from './constants/album-ebads';
import Footer from "./footer";
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';

class Home extends Component {

    constructor(props) {
        super(props);

        this.albumList = Object.entries(albumEbads);

        this.state = {
            lightboxOpen: false,
            lightboxIndex: 0,
        };
    }

    openLightbox(index) {
        this.setState({
            lightboxOpen: true,
            lightboxIndex: index,
        });
    }

    closeLightbox() {
        this.setState({
            lightboxOpen: false,
        });
    }

    getEbatSummary(album) {
        if (album.all) {
            return 'Tüm ebatlar';
        }

        if (album.ebads.length <= 3) {
            return album.ebads.join(' · ');
        }

        return `${album.ebads.slice(0, 3).join(' · ')} +${album.ebads.length - 3}`;
    }

    renderLightboxCaption() {
        const album = this.albumList[this.state.lightboxIndex][1];

        return (
            <div className="home-album-lightbox-caption">
                <span>{this.getEbatSummary(album)}</span>
            </div>
        );
    }

    render() {
        const lightboxImages = this.albumList.map(([, album]) => album.image);

        return (
            <div>
                <Header/>
                <main className="index">

                    <div className="main-container-top" id="video-container">
                        <video autoPlay loop muted>
                            <source src={katalog} type="video/mp4"/>
                            Your browser does not support HTML5 video.
                        </video>

                        <div className="text">
                            <div className="container">
                                <div className="text-container">
                                    <h1> Saydam Albüm </h1>
                                    <h4> " Her anınızda sizinleyiz.. " </h4>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="container">
                        <div className="main-container">
                            <section className="album-showcase">
                                <div className="album-showcase-header">
                                    <h5 className="main-title">
                                        Albümlerimiz
                                    </h5>
                                    <p className="album-showcase-subtitle">
                                        SA-101 ile SA-130 arası {this.albumList.length} kapak modeli
                                    </p>
                                </div>

                                <div className="album-showcase-grid">
                                    {this.albumList.map(([key, album], index) => (
                                        <button
                                            type="button"
                                            className="album-showcase-card"
                                            key={key}
                                            onClick={() => this.openLightbox(index)}
                                        >
                                            <div className="album-showcase-card-image">
                                                <img
                                                    src={album.image}
                                                    alt={album.name}
                                                    loading="lazy"
                                                />
                                                <span className="album-showcase-card-zoom">
                                                    <i className="material-icons">zoom_in</i>
                                                </span>
                                            </div>
                                            <div className="album-showcase-card-body">
                                                <strong>{album.name}</strong>
                                                <small>{this.getEbatSummary(album)}</small>
                                                {album.all ? (
                                                    <span className="album-showcase-badge">Tüm ebatlar</span>
                                                ) : null}
                                            </div>
                                        </button>
                                    ))}
                                </div>
                            </section>
                        </div>
                    </div>
                </main>

                {this.state.lightboxOpen ? (
                    <Lightbox
                        mainSrc={lightboxImages[this.state.lightboxIndex]}
                        nextSrc={lightboxImages[(this.state.lightboxIndex + 1) % lightboxImages.length]}
                        prevSrc={lightboxImages[(this.state.lightboxIndex + lightboxImages.length - 1) % lightboxImages.length]}
                        onCloseRequest={this.closeLightbox.bind(this)}
                        onMovePrevRequest={() => this.setState({
                            lightboxIndex: (this.state.lightboxIndex + lightboxImages.length - 1) % lightboxImages.length,
                        })}
                        onMoveNextRequest={() => this.setState({
                            lightboxIndex: (this.state.lightboxIndex + 1) % lightboxImages.length,
                        })}
                        imageTitle={this.albumList[this.state.lightboxIndex][1].name}
                        imageCaption={this.renderLightboxCaption()}
                    />
                ) : null}

                <Footer/>
            </div>
        );
    }
}

export default Home;
